export const loginInputs =[
    {
     id:1,
     lable: 'Your username',
     variant : "standard",
     name : "username",
     type:"text"

    },
    {
     id:2,
     lable:"Your password",
     variant : "standard",
     name:"password",
     type:"password"
     
    }
  ]
